/**
 * Created by user on 2020/5/11.
 */

import mod = require('@novel-segment/stream-loader-core/stream');
export = mod;
